<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 12 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <!-- THIN -->
        <path
            v-if="weight === 'THIN'"
            d="M0.175736 0.175736C0.41005 -0.0585786 0.789949 -0.0585786 1.02426 0.175736L5.93333 5.0848L10.8424 0.175736C11.0767 -0.0585786 11.4566 -0.0585786 11.6909 0.175736C11.9252 0.41005 11.9252 0.789949 11.6909 1.02426L6.3576 6.3576C6.12328 6.59191 5.74338 6.59191 5.50907 6.3576L0.175736 1.02426C-0.0585786 0.789949 -0.0585786 0.41005 0.175736 0.175736Z"
            fill="currentColor"
        />
        <!-- REGULAR -->
        <path
            v-else-if="weight === 'REGULAR'"
            d="M0.175736 0.175736C0.41005 -0.0585786 0.789949 -0.0585786 1.02426 0.175736L5.93333 5.0848L10.8424 0.175736C11.0767 -0.0585786 11.4566 -0.0585786 11.6909 0.175736C11.9252 0.41005 11.9252 0.789949 11.6909 1.02426L6.3576 6.3576C6.12328 6.59191 5.74338 6.59191 5.50907 6.3576L0.175736 1.02426C-0.0585786 0.789949 -0.0585786 0.41005 0.175736 0.175736Z"
            fill="currentColor"
        />
        <!-- FILL -->
        <path
            v-else
            d="M0.175736 0.175736C0.41005 -0.0585786 0.789949 -0.0585786 1.02426 0.175736L5.93333 5.0848L10.8424 0.175736C11.0767 -0.0585786 11.4566 -0.0585786 11.6909 0.175736C11.9252 0.41005 11.9252 0.789949 11.6909 1.02426L6.3576 6.3576C6.12328 6.59191 5.74338 6.59191 5.50907 6.3576L0.175736 1.02426C-0.0585786 0.789949 -0.0585786 0.41005 0.175736 0.175736Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: 'chevron-down-icon',
    props: {
        width: {
            type: [String, Number],
            default: 12,
        },
        height: {
            type: [String, Number],
            default: 7,
        },
        color: {
            type: String,
            default: 'text-black',
        },
        weight: {
            type: String,
            default: 'THIN',
            validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
        },
    },
};
</script>